export const USER_DETAILS = "USER_DETAILS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const SIGNUP_ERROR = "SIGNUP_ERROR";
export const AUTHENTICATED = "AUTHENTICATED";
